module.exports = __webpack_public_path__ + "static/media/resetPass.aff5ed86.svg";